/* eslint-disable @typescript-eslint/default-param-last */
import { IQuestionActionType } from "@/types/questions.types";
import {
  ADD_QUESTION,
  END_INTERVIEW_FOR_ALL,
  GET_ALL_QUESTIONS,
  LEAVE_INTERVIEW,
  MOVE_CANDIDATE_TO_LOBBY,
  REMOVE_QUESTION,
  UPDATE_QUESTION,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const questionsReducer = (
  state = initialState.questionsDetails,
  action: IQuestionActionType,
) => {
  switch (action.type) {
    case `${GET_ALL_QUESTIONS}_SUCCESS`:
      return {
        ...state,
        questions: action.payload.questions,
      };
    case `${ADD_QUESTION}_SUCCESS`:
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.payload.question.slug]: action.payload.question,
        },
      };
    case `${UPDATE_QUESTION}_SUCCESS`:
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.payload.question.slug]: action.payload.question,
        },
      };
    case `${REMOVE_QUESTION}_SUCCESS`: {
      const questions = { ...state.questions };
      delete questions[action.payload.questionSlug];
      return {
        ...state,
        questions,
      };
    }
    case `${LEAVE_INTERVIEW}_SUCCESS`:
    case `${MOVE_CANDIDATE_TO_LOBBY}_SUCCESS`:
    case `${END_INTERVIEW_FOR_ALL}_SUCCESS`:
      return initialState.questionsDetails;
    default:
      return state;
  }
};

export default questionsReducer;
